import type { MenuType } from '../../../../types/menu';

/**
 * UI-only display labels for `MenuType`. The backend enum values stay
 * unchanged (FULL, BY_THE_GLASS, RESERVE, ...) — this helper just gives the
 * admin surface friendlier copy that reflects the post-4.H mental model:
 *
 *   wine-list types  → "Wine List · <variant>"
 *   cocktail/etc.    → "<Foo> Menu"
 *
 * Use in chips, table cells, and dropdown option labels — never on payloads
 * sent to the API.
 */
export const MENU_TYPE_LABELS: Record<MenuType, string> = {
  FULL: 'Wine List · Full',
  BY_THE_GLASS: 'Wine List · By the Glass',
  RESERVE: 'Wine List · Reserve',
  EVENT: 'Wine List · Event',
  PRIVATE: 'Wine List · Private',
  COCKTAIL: 'Cocktail Menu',
  FOOD: 'Food Menu',
  BEER: 'Beer Menu',
  SPIRITS: 'Spirits Menu',
  TASTING: 'Tasting Menu',
  RETAIL: 'Retail Menu',
  MIXED: 'Mixed Menu',
  OTHER: 'Other Menu',
};

export const menuTypeLabel = (type: MenuType): string =>
  MENU_TYPE_LABELS[type] ?? type;
